import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom"; // Importación añadida para manejar la ubicación
import { extarerCotizacionesCliente } from "../../../../store/cotizaciones/thunkCotizaciones";

export const Cotizaciones = () => {
    // Configuración de columnas de la tabla con claves y cabeceras
    const COLUMNAS_TABLA = [
        { key: "id_consecutivo_coti", header: "ID Consecutivo" },
        { key: "nombre_evento_coti", header: "Nombre del Evento" },
        { key: "Estado_coti", header: "Estado" },
    ];

    const dispatch = useDispatch();
    const { search } = useLocation(); // Obtenemos los parámetros de búsqueda de la URL
    const [cotizaciones, setCotizaciones] = useState([]); // Estado para almacenar las cotizaciones
    const [error, setError] = useState(null); // Estado para manejar errores

    /**
     * Obtiene un parámetro numérico de la URL
     * @param {string} parametro - Nombre del parámetro a extraer
     * @returns {number|string} - Valor del parámetro convertido a número si es posible
     */
    const obtenerParametroNumerico = (parametro) => {
        const valorParametro = new URLSearchParams(search).get(parametro);

        // Convertimos a número si el valor es válido
        if (valorParametro && !isNaN(valorParametro)) {
            return Number(valorParametro);
        }
        return valorParametro;
    };

    /**
     * Obtiene las cotizaciones desde la API usando Redux
     * @param {number} idCliente - ID del cliente para filtrar cotizaciones
     */
    const obtenerCotizaciones = async (idCliente) => {
        try {
            const resultado = await dispatch(extarerCotizacionesCliente(idCliente));
            setCotizaciones(resultado);
            setError(null);
        } catch (error) {
            console.error("Error obteniendo cotizaciones:", error);
            setError("Error al cargar las cotizaciones");
            setCotizaciones([]);
        }
    };

    // Efecto para cargar cotizaciones al montar el componente o cambiar parámetros
    useEffect(() => {
        const idCliente = obtenerParametroNumerico("data");

        if (idCliente && idCliente > 0) {
            obtenerCotizaciones(idCliente);
        } else {
            setError("ID de cliente no válido");
            setCotizaciones([]);
        }
    }, [search]); // Se reactiva cuando cambian los parámetros de búsqueda

    // Hook to navigate between application routes
    const navigate = useNavigate();

    const irTransaccion = (id) => {
        navigate(`/cotizaciones/view?data=${id}`); // Navegación a otra vista
    };

    return (
        <section className="container-fluid">
            {/* Sección de cabecera informativa */}
            <div className="card mb-4">
                <div className="card-header text-white">
                    <h5 className="mb-0">Gestión de Cotizaciones</h5>
                </div>
                <div className="card-body">
                    <p className="lead">
                        Visualización detallada de las cotizaciones asociadas al cliente. Aquí podrás revisar el histórico completo de propuestas
                        comerciales.
                    </p>
                </div>
            </div>

            {/* Sección de tabla de resultados */}
            <div className="card">
                <div className="card-header">
                    <h5>Registro de Cotizaciones</h5>
                </div>

                <div className="card-body">
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}

                    {cotizaciones.length === 0 && !error && (
                        <div className="alert alert-info" role="alert">
                            No se encontraron cotizaciones registradas
                        </div>
                    )}

                    <table className="table table-hover table-striped">
                        <thead className="thead-dark">
                            <tr>
                                {COLUMNAS_TABLA.map((columna) => (
                                    <th key={columna.key} scope="col">
                                        {columna.header}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {cotizaciones.map((cotizacion) => (
                                <tr
                                    key={cotizacion.id_consecutivo_coti}
                                    onClick={() => irTransaccion(cotizacion.id_coti)}
                                    style={{ cursor: "pointer" }}
                                    className="hover:bg-gray-50" // Opcional: efecto hover
                                >
                                    {COLUMNAS_TABLA.map((columna) => (
                                        <td key={`${cotizacion.id_consecutivo_coti}-${columna.key}`}>{cotizacion[columna.key]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};
